import React from "react"

const NotFound = () => <React.Fragment>Page not found!</React.Fragment>

export default NotFound
